export default __webpack_public_path__ + "static/media/beach.86df0db9.png";